import clsx from 'clsx'
import React from 'react'
import Link from '../../routes/link'
import s from './icon-button.module.css'

interface BaseProps {
  className?: string
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
  children?: React.ReactNode
  cta?: boolean
  active?: boolean
}

interface ButtonProps extends BaseProps {
  to?: undefined
  type?: 'submit' | 'button' | 'reset' | 'file'
  disabled?: boolean
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

interface LinkProps extends BaseProps {
  to: string
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void
}

type Props = ButtonProps | LinkProps

export const IconButton: React.FC<Props> = (props) => {
  const {
    children,
    icon: Icon,
    cta = false,
  } = props

  const className = clsx(
    props.className,
    s.button,
    {
      [s.cta]: cta,
      [s.active]: props.active
    }
  )

  const labelComponent = <>
    {Icon && <Icon className={s.icon} />}
    {children && <span className={s.label}>{children}</span>}
  </>

  if (!('to' in props)) {
    // Rendering a <button>
    const { onClick, onChange, type, disabled } = props

    if (type === 'file') {
      return <label className={className}>
        {labelComponent}
        <input
          type="file"
          onChange={onChange}
          disabled={disabled}
          className={s.fileInput}
        />
      </label>

    }

    return <button
      onClick={onClick}
      className={className}
      type={type ?? 'button'}
      disabled={disabled}
    >
      {labelComponent}
    </button>
  }

  // Rendering a <Link>
  const { to, onClick } = props

  return <Link to={to} onClick={onClick} className={className}>
    {labelComponent}
  </Link>
}

export default IconButton
